var map = {
	"./apiPartners.js": "1085",
	"./auth.js": "11c0",
	"./companies.js": "d5ad",
	"./dashBoard.js": "1617",
	"./eMoney.js": "9e01",
	"./fundRequests.js": "a0e9",
	"./orders.js": "c9f0",
	"./products.js": "22ca",
	"./reports.js": "2123",
	"./users.js": "b20d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";